






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class XPIcon extends Vue {
  @Prop({ type: String, required: false, default: 'grey' }) private readonly color!: string;
  @Prop({ type: Boolean, required: false, default: true }) private readonly translucid!: string;
}
